export enum SignatoryDetailEvents {
  SignatoryDetailsBrowse = 'signatory_details_browse',
  SignatoryDetailsUploadSuccess = 'signatory_details_upload_success',
  SignatoryDetailsUploadFailed = 'signatory_details_upload_failed',
  SignatoryDetailsSave = 'signatory_details_save',
}
